// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__JsrTn","fadeIn":"dialog_fadeIn__k4Bwz","backdropFadeIn":"dialog_backdropFadeIn__z2iqO"};